<template>
    <div>
        <v-flex>
            <!-- Weekly Sales -->
            <v-layout>
                <app-card
                    colClasses="xl12 lg12 md12 sm6 xs12"
                    :heading="$t('lang.WeeklySales')"
                    :fullBlock="true"
                    :fullScreen="true"
                    :reloadable="true"
                    :closeable="true"
                    customClasses="weekly-sales-widegt"
                >
                    <div class="pl-4">
                        <h5 class="mb-0 fw-bold">2578</h5>
                        <p class="fs-12 grey--text">+35% from last week</p>
                    </div>
                    <weekly-sales :enableXAxesLine="false"> </weekly-sales>
                </app-card>
            </v-layout>
        </v-flex>
    </div>
</template>
<script>
import LineChartShadow from "Components/Charts/Default/LineChartShadow";
import Sales from "Components/Charts/Default/SalesChartV2";
import LineChartWithArea from "Components/Charts/Default/LineChartWithArea";

import WeeklySales from "App_components/Widgets/WeeklySales.vue";
import { ChartConfig } from "Constants/chart-config";

export default {
    components: {
        LineChartShadow,
        Sales,
        LineChartWithArea,
        WeeklySales,
    },
    data() {
        return {
            name: "weekly_sales",
            ChartConfig,
            labels: ["A", "B", "C", "D", "E", "F", "J", "K", "L", "M", "N", "P"],
            totalEarnings: [30, 50, 25, 55, 44, 60, 30, 20, 40, 20, 40, 44],
            onlineRevenue: [30, 50, 25, 55, 44, 60, 30, 20, 40, 20, 40, 44],
            newCustomers: [30, 50, 25, 55, 44, 60, 30, 20, 40, 20, 40, 44],
        };
    },
};
</script>
